import type {
  AppMountContext,
  DialogOutcome,
  DialogRequest,
  DialogService,
  NavigationOptions,
  PlatformBus
} from "@tc-superpods/app-contract";
import { mode, registryApiBaseUrl } from "./config";
import type { DialogController } from "./dialog-controller";
import type { RegistryEntry, Workspace } from "./types";

export interface MountContextDeps {
  bus: PlatformBus;
  identity: AppMountContext["identity"];
  tenant: AppMountContext["tenant"];
  href: (to: string, options?: NavigationOptions) => string;
  navigate: (to: string, options?: NavigationOptions) => void;
  dialogController: DialogController;
}

export function createMountContext(
  entry: RegistryEntry,
  registry: RegistryEntry[],
  deps: MountContextDeps,
  basePath: string,
  initialPath: string,
  workspace: Workspace | null,
  workspaces: Workspace[],
  variables: Record<string, string>
): AppMountContext {
  return {
    appId: entry.id,
    basePath,
    initialPath,
    availableApps: registry,
    availableWorkspaces: workspaces,
    href: deps.href,
    navigate: deps.navigate,
    identity: deps.identity,
    tenant: deps.tenant,
    workspace,
    variables,
    registryApiBaseUrl,
    bus: deps.bus,
    dialogs: createDialogService(entry.id, deps.dialogController),
    logger: console,
    mode
  };
}

function createDialogService(ownerAppId: string, controller: DialogController): DialogService {
  return {
    open<TInput, TResult>(request: DialogRequest<TInput, TResult>): Promise<DialogOutcome<TResult>> {
      return controller.open(ownerAppId, request);
    }
  };
}
